import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMaterialPurchaseApproveColor } from '@/api/MES/produceManagement.js';
export default {
  name: 'V',
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  },
  data: function data() {
    return {
      data: [],
      loading: false,
      imgPrefix: process.env.NODE_ENV === "development" ? "http://orderplus-cloud-test.oss-cn-hongkong.aliyuncs.com/orderPlus/" : "" // 图片前缀
    };
  },

  methods: {
    getProcessPlateList: function () {
      var _getProcessPlateList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.next = 3;
              return getMaterialPurchaseApproveColor(id);
            case 3:
              result = _context.sent;
              if (result.code === 200) {
                this.data = result.data;
                this.loading = false;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProcessPlateList(_x) {
        return _getProcessPlateList.apply(this, arguments);
      }
      return getProcessPlateList;
    }(),
    downloadFile: function downloadFile(val) {
      var url = this.imgPrefix + val;
      window.open(url);
    }
  }
};